<template>
  <div class="page">
    <commonHeader heading="信息加工有效评估" subtitle="">
      <template v-slot:add>
        <div style="cursor: pointer;color: #fff;" @click="toDigitalAllData()">
          <span>全部数据</span>
          <span class="mdi mdi-chevron-right"></span>
        </div>
      </template>
    </commonHeader>
    <!-- 信息加工有效评估 -->
    <div class="big-title">
      <div class="left-title">不同信息加工方式对学习结果影响效果评估表</div>
      <div class="right-detail">
        <span class="title-icon mdi mdi-refresh"></span>
        <span class="title-icon mdi mdi-fullscreen icon-mrl" @click="fullScreenDisplay('digitalOne')"></span>
      </div>
    </div>
    <div class="course-data">
      <div class="course-row">
        <v-card>
          <div class="course-echart">
            <div id="digitalOne"></div>
          </div>
        </v-card>
      </div>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import CommonHeader from '@/components/DataService/CommonHeader.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    CommonHeader
  },
  data() {
    return {
      digitalOne: false,
    };
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  watch: {
    'isMobile.isMobile'(news) {
      if (!news) {
        setTimeout(() => {
          this.digitalOne.dispose();
          this.getChartDataTwo();
        }, 500);
      }
    },
  },

  created() {

  },

  mounted() {
    this.getChartDataOne()
  },

  methods: {
    getChartDataOne() {
      this.digitalOne = echarts.init(document.getElementById('digitalOne'));
      var option;

      option = {
        title: {
          // text: 'Stacked Line'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['仿真互动', '视屏微课','视屏慕课（数字人）','图片','音频','文档']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['引用的任务数', '资源收藏次数', '累计浏览人次', '关联知识点测试得分率', '引用任务完学率', '引用任务完学率']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '仿真互动',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 81, 134, 90, 230]
          },
          {
            name: '视屏微课',
            type: 'line',
            stack: 'Total',
            data: [35, 182, 191, 234, 290, 500]
          },
          {
            name: '视屏慕课（数字人）',
            type: 'line',
            stack: 'Total',
            data: [65, 192, 111, 24, 300, 260]
          },
          {
            name: '图片',
            type: 'line',
            stack: 'Total',
            data: [85, 222, 101, 34, 200, 190]
          },
          {
            name: '音频',
            type: 'line',
            stack: 'Total',
            data: [15, 172, 191, 120, 100, 150]
          },
          {
            name: '文档',
            type: 'line',
            stack: 'Total',
            data: [19, 192, 161, 190, 90, 110]
          },
        ]
      };

      this.digitalOne.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.digitalOne.resize();
      });
    },
    fullScreenDisplay(id) {
      var element = document.getElementById(id);
      var requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen;
      if (requestFullScreen) {
          // 进入全屏
          requestFullScreen.call(element);
          // element.style.backgroundColor = '#fff';
      }
    },
    toDigitalAllData() {
      this.$router.push({
        name: 'InfoAllData',
        query: {
          detailId: 1,
        },
      });
    },
  }
}
</script>

<style scoped>
.page {
  padding: 10px;

  .big-title {
    display: flex;
    padding: 20px 1px 5px;
    
    .left-title {
      font-size: 18px;
      flex: 1;
      text-align: left;
    }

    .right-detail {
      cursor: pointer;
      text-align: right;
      display: flex;
      .title {
        font-size: 16px !important;
        flex: 1;
        height: 35px;
        line-height: 35px;
      }
      .title-icon {
        font-size: 20px !important;
      }
      .icon-mrl {
        margin-left: 5px;
      }
    }
  }

  .course-data {
    display: flex;
    margin-bottom: 15px;
    .course-row {

      .v-card {
        height: 100%;
      }

      flex: 1;

      .course-header {
        font-size: 20px;
        padding: 10px 5px;
      }

      .course-echart {
        padding: 10px 0;
        text-align: center;
        #digitalOne,
        #digitalTwo {
          display: inline-block;
          width: 100%;
          height: 450px;
        }
      }
    }
  }
}
</style>